import axios from "axios";

import { API_URL } from "./conection";
//Todos los forms
export const getAllSavedForms = async (
  page = 1,
  limit = 20,
  sortBy = "FechaFormulario",
  sortDir = "desc",
  search = "",
  contentFilter = "",
  { centerName = "", centerNames = "", fromDate = "", toDate = "" } = {}
) => {
  try {
    const params = { page, limit, sortBy, sortDir, search };
    if (contentFilter) params.contentFilter = contentFilter;
    if (centerName) params.centerName = centerName;
    if (centerNames) params.centerNames = centerNames;
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    const res = await axios.get(`${API_URL}/get-all-saved-forms-op`, { params });
    return res.data;
  } catch (error) {
    console.error("Error en getAllSavedForms:", error);
    return {
      success: false,
      data: [],
      pagination: {
        page,
        limit,
        sortBy,
        sortDir,
        search,
        total: 0,
        totalPages: 0,
        hasMore: false,
      },
    };
  }
};

// Todos mis forms
export const getMySavedForms = async (
  username,
  page = 1,
  limit = 20,
  sortBy = "FechaFormulario",
  sortDir = "desc",
  search = "",
  contentFilter = "",
  { centerName = "", fromDate = "", toDate = "" } = {}
) => {
  try {
    const params = { page, limit, sortBy, sortDir, search };
    if (contentFilter) params.contentFilter = contentFilter;
    if (centerName) params.centerName = centerName;
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    const res = await axios.get(
      `${API_URL}/my-saved-forms-op/${encodeURIComponent(username)}`,
      { params }
    );
    return res.data;
  } catch (error) {
    console.error("Error en getMySavedForms:", error?.response?.status, error?.message || String(error));
    return {
      success: false,
      data: [],
      pagination: {
        page,
        limit,
        sortBy,
        sortDir,
        search,
        total: 0,
        totalPages: 0,
        hasMore: false,
      },
    };
  }
};


export const getSavedForm = async (idForm) => {
  try {
    const res = await axios.get(`${API_URL}/saved-form/${encodeURIComponent(idForm)}`);
    return res.data;
  } catch (error) {
    console.error("Error en getSavedForm:", error);
    return null;
  }
};

export const saveSavedForms = async (data) => {
  try {
    const res = await axios.post(`${API_URL}/save-saved-forms`, data);
    return res.data;
  } catch (error) {
    console.error("Error en saveSavedForms:", error);
    return null;
  }
};

export const updateSavedForm = async (idForm, data) => {
  try {
    const res = await axios.put(`${API_URL}/update-saved-forms/${encodeURIComponent(idForm)}`, data);
    return res.data;
  } catch (error) {
    console.error("Error en updateSavedForm:", error);
    return null;
  }
};

export const deleteSavedForm = async (idForm) => {
  try {
    const res = await axios.delete(`${API_URL}/delete-saved-forms/${encodeURIComponent(idForm)}`);
    return res.data;
  } catch (error) {
    console.error("Error en deleteSavedForm:", error);
    return null;
  }
};

export const getDeletedForms = async (page = 1, limit = 20, search = "") => {
  try {
    const params = { page, limit };
    if (search) params.search = search;
    const res = await axios.get(`${API_URL}/internal/ops/deleted`, { params });
    return res.data;
  } catch (error) {
    console.error("Error en getDeletedForms:", error);
    return { success: false, data: [], pagination: { page, limit, total: 0, totalPages: 0, hasMore: false } };
  }
};

export const restoreSavedForm = async (idForm) => {
  try {
    const res = await axios.patch(`${API_URL}/internal/ops/restore/${encodeURIComponent(idForm)}`);
    return res.data;
  } catch (error) {
    console.error("Error en restoreSavedForm:", error);
    return null;
  }
};

export const hardDeleteSavedForm = async (idForm) => {
  try {
    const res = await axios.delete(`${API_URL}/internal/ops/hard-delete/${encodeURIComponent(idForm)}`);
    return res.data;
  } catch (error) {
    console.error("Error en hardDeleteSavedForm:", error);
    return null;
  }
};
